import Grid from "components/grid";
import ListHead from "components/subHead/listHead";
import { useSearchList } from "./service";
import { detail } from "./handles";
import useModalStore from "store/modal";
import UserDetail from "./detail";

export default function UserList() {
  const { rowData, pageNav } = useSearchList();
  const onSetModal = useModalStore((state) => state.onSetModal);
  const theads = [
    ...prevTheads,
    {
      langNm: "grid_detail",
      type: "detail",
      field: "detail",
      width: 80,
      click: (props: any) => {
        // 상세
        detail(props);
        onSetModal({
          title: "회원상세",
          isOpen: true,
          styles: "w-full",
          inner: <UserDetail />,
        });
      },
    },
  ];
  return (
    <>
      <ListHead totalRows={pageNav ? pageNav.totalRows : 0} />
      <Grid theads={theads} rowData={rowData} pageNav={pageNav} />
    </>
  );
}

const prevTheads = [
  {
    langNm: "grid_no",
    type: "id",
    field: "No",
    width: 60,
  },
  {
    langNm: "grid_mem_no",
    type: "string",
    field: "memNo",
  },

  {
    langNm: "grid_mem_surnm",
    type: "string",
    field: "memSurnm",
    width: 100,
  },
  {
    langNm: "grid_mem_fstnm",
    type: "string",
    field: "memFstnm",
    width: 140,
  },
  {
    langNm: "grid_eml",
    type: "string",
    field: "emlId",
  },
  {
    langNm: "grid_phone",
    type: "phone",
    field: "mobNo",
  },
];
